export * from "../global/social-x";
